import {TiMeLogger} from 'features/logger';

export const TiMeDraftsLogger = TiMeLogger.child({
    name: 'drafts',
});
